import React from 'react'
import useMobile from '../../hooks/useMobile'
import DGRDesktop from './DGRDesktop'
import { useDGR } from './hooks/useDGR'
import DGRMobileView from './components/DGRMobileView'

const DailyGenerationReport = () => {
    const isMobile = useMobile()
    const logic = useDGR()

    if (isMobile) {
        return <DGRMobileView logic={logic} />
    }

    return <DGRDesktop logic={logic} />
}

export default DailyGenerationReport
